import * as z from 'zod';

export const userFormSchema = z.object({
  first_name: z
    .string()
    .nonempty('First name is required')
    .min(2, 'First name must be at least 2 characters'),
  last_name: z.string().optional(),
  email: z
    .string()
    .nonempty('Email is required')
    .email('Please enter a valid email address'),
  role_id: z.string().nonempty('Please select a role'),
});

export type UserFormData = z.infer<typeof userFormSchema>;

